import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBarChart4Bars = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: 20,
	viewBox: "0 -960 960 960",
	width: 20,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M96-144v-72h768v72H96Zm48-120v-264h96v264h-96Zm192 0v-456h96v456h-96Zm192 0v-336h96v336h-96Zm192 0v-552h96v552h-96Z" })
});
export default SvgBarChart4Bars;
